import StyleConfTemplate from './StyleConfTemplate';
import Wradio from '../../../../builtin/components/Radio';
import { intersection } from "lodash-es";
import StylePanelMixin from '../utils/StylePanelMixin';
const __script_base__ = {
  name: 'SPOverflow',
  extends: StylePanelMixin,
  components: {
    StyleConfTemplate,
    Wradio
  },
  data() {
    const h = this.$createElement;
    return {
      currentOverflow: 'overflow',
      overflowDirections: [{
        name: '全向',
        field: 'overflow',
        icon: 'fa fa-arrows'
      }, {
        name: '横向',
        field: 'overflowX',
        icon: 'fa fa-arrows-h'
      }, {
        name: '纵向',
        field: 'overflowY',
        icon: 'fa fa-arrows-v'
      }],
      flowOptions: [{
        label: h("span", {
          "attrs": {
            "title": "visible"
          },
          "class": "ucd-stylePanel-enumBox"
        }, ["\u53EF\u89C1"]),
        value: 'visible'
      }, {
        label: h("span", {
          "attrs": {
            "title": "hidden"
          },
          "class": "ucd-stylePanel-enumBox"
        }, ["\u9690\u85CF"]),
        value: 'hidden'
      }, {
        label: h("span", {
          "attrs": {
            "title": "scroll"
          },
          "class": "ucd-stylePanel-enumBox"
        }, ["\u6EDA\u52A8"]),
        value: 'scroll'
      }]
    };
  },
  computed: {
    currentOverflowVal: {
      get() {
        return this.style[this.currentOverflow] || this.style.overflow;
      },
      set(val) {
        this.setStyle(this.currentOverflow, val);
      }
    },
    changed() {
      return intersection(Object.keys(this.style), ['overflow', 'overflowX', 'overflowY']).length > 0;
    }
  },
  methods: {
    resetOverflow() {
      this.deleteStyle('overflow');
      this.deleteStyle('overflowX');
      this.deleteStyle('overflowY');
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("StyleConfTemplate", {
    attrs: {
      name: "溢出",
      changed: _vm.changed,
      inline: true
    },
    on: {
      reset: _vm.resetOverflow
    }
  }, [_c("div", {
    staticClass: "ucd-stylePanel-wrapFlexLine"
  }, [_c("a-select", {
    staticStyle: {
      width: "85px"
    },
    model: {
      value: _vm.currentOverflow,
      callback: function ($$v) {
        _vm.currentOverflow = $$v;
      },
      expression: "currentOverflow"
    }
  }, _vm._l(_vm.overflowDirections, function (option, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: option.field
      }
    }, [_c("div", {
      style: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center"
      }
    }, [_c("i", {
      class: option.icon,
      staticStyle: {
        "margin-right": "5px"
      }
    }), _vm._v(_vm._s(option.name) + "\n        ")])]);
  }), 1), _vm._v(" "), _c("Wradio", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentOverflow === "overflowX",
      expression: "currentOverflow === 'overflowX'"
    }],
    attrs: {
      "with-solid-fill": "",
      value: _vm.currentOverflowVal,
      options: _vm.flowOptions
    },
    on: {
      change: function (val) {
        return _vm.changeAndDelete(_vm.currentOverflow, val);
      }
    }
  }), _vm._v(" "), _c("Wradio", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentOverflow === "overflowY",
      expression: "currentOverflow === 'overflowY'"
    }],
    attrs: {
      "with-solid-fill": "",
      value: _vm.currentOverflowVal,
      options: _vm.flowOptions
    },
    on: {
      change: function (val) {
        return _vm.changeAndDelete(_vm.currentOverflow, val);
      }
    }
  }), _vm._v(" "), _c("Wradio", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentOverflow === "overflow",
      expression: "currentOverflow === 'overflow'"
    }],
    attrs: {
      "with-solid-fill": "",
      value: _vm.currentOverflowVal,
      options: _vm.flowOptions
    },
    on: {
      change: function (val) {
        return _vm.changeAndDelete(_vm.currentOverflow, val);
      }
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/PropPanel/StylePanel/comps/overflow.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);